module.exports = __webpack_public_path__ + "static/img/image083.cef8cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image083.png
// module id = 7Tgi
// module chunks = 1